/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { ALERT_FAIL, CVE_ESTATUS_TERCERO, SECTIONS } from "../../app/constantes"
import { useDispatch, useSelector } from "react-redux";
import { appState, setAlert } from "../../slices/appSlice";
import InputComp from "../generales/inputComponent";
import { seleccionTerceroFrom } from "../../app/forms/cobros/datosFiscales";
import { changeSection, pagosState, setModalDatosFiscales, setModalFactura, setModalSeleccionTercero, setTerceroSeleccionado } from "../../slices/pagosSlice";
import { getFacturacionTercerosRegistrados} from "../../services/cobro";
import { setModalFactura as setModalFacturaCursos, setModalDatosFiscales as setModalDatosFiscalesCursos, changeSectionCobroCurso } from "../../slices/pagosCursosSlice";



export default function ModalTipoPago({idEntidad, type}) {
    const dispatch = useDispatch()

    const appSt = useSelector(appState);
    const pagosSt = useSelector(pagosState);

    const [form, setForm] = useState(JSON.parse(JSON.stringify(seleccionTerceroFrom)));
    const [pagoTercero, setPagoTercero] = useState(false)
    const [terceros, setTerceros] = useState([])

    const closeModal = () => {
        setForm(JSON.parse(JSON.stringify(seleccionTerceroFrom)))
        setTerceros(null)
        setPagoTercero(false)
        dispatch(setModalSeleccionTercero({
            show: false,
            data: null,
            type: null
        }))
    }

    const handleSubmit = async () => {
        if ((pagoTercero && terceros.length === 0)) {
            closeModal()
            if (type && type === "cursos") {
                dispatch(changeSectionCobroCurso(SECTIONS.five))
            } else {
                dispatch(changeSection(SECTIONS.five))
            }
             
        } else if (!pagoTercero || (pagoTercero && form.idPersonaTercero.value !== "")) {
            
            if (pagoTercero && terceros) {
                const tercero = terceros.find(item => Number(item.idPersonaTercero) === Number(form.idPersonaTercero.value))
                dispatch(setTerceroSeleccionado(tercero))
            } else {
                dispatch(setTerceroSeleccionado(null))
            }
            if (pagosSt.modalSeleccionarTercero.data.facturaAnticipada.value === 'true' && !pagosSt.modalSeleccionarTercero.type) {
                if (type && type === "cursos") {
                    dispatch(setModalFacturaCursos({
                        show: true,
                        data: {type: 'anticipada'}
                    }))
                } else {
                    dispatch(setModalFactura({
                        show: true,
                        data: {type: 'anticipada'}
                    }))
                }
            }
            if (pagosSt.modalSeleccionarTercero.type && pagosSt.modalSeleccionarTercero.type === "normal") {
                if (type && type === "cursos") {
                    dispatch(setModalFacturaCursos({
                        show: true,
                        data: {type: 'normal'}
                    }))
                } else {
                    dispatch(setModalFactura({
                        show: true,
                        data: {type: 'normal'}
                    }))
                }
            }
            if (pagosSt.modalSeleccionarTercero.data.metodoPago.value === 'depositoBancario') {
                if (type && type === "cursos") {
                    dispatch(setModalDatosFiscalesCursos({
                        show: true,
                        data: null
                    }))
                } else {
                    dispatch(setModalDatosFiscales({
                        show: true,
                        data: null
                    }))
                }
            }
            if (pagosSt.modalSeleccionarTercero.data.metodoPago.value === 'pagoLinea') {
                if (type === "cursos") {
                    dispatch(changeSectionCobroCurso(SECTIONS.four))
                } else {
                    dispatch(changeSection(SECTIONS.four))
                }
            }
            closeModal()
        } else {
            dispatch(setAlert({
                show: true,
                message: 'Favor de llenar los campos requeridos',
                type: ALERT_FAIL
            }))
        }
    }

    const getData = async () => {
        try {
            const resp = await getFacturacionTercerosRegistrados({
                ...appSt.serviceData,
                idEntidad: idEntidad ? idEntidad : pagosSt.currentConvocatoria.idEntidad,
            })
            console.log(resp)
            if (resp && resp.payload && resp.payload.length > 0) {
                const activos = resp.payload.filter((item) => item.cveEstatusFacturaTercero === CVE_ESTATUS_TERCERO.confirmada)
                setTerceros(activos)
            }
        } catch (error) {
            console.error(error)
            dispatch(setAlert({
                show: true,
                message: 'Error al consultar información',
                type: ALERT_FAIL
            }))
        }
    }
    
    useEffect(() => {
        if (pagoTercero) {
            getData()
        }
    }, [pagoTercero])

    useEffect(() => {
        console.log(pagosSt.modalSeleccionarTercero)
    }, [pagosSt.modalSeleccionarTercero])

    return (
        <div className={pagosSt.modalSeleccionarTercero.show ? 'modal-wrapper active' : 'modal-wrapper'}>
            <div className="modal modal-tipo-pago">
                <div className="head">
                    <h3>Datos de facturación</h3>
                    <button onClick={closeModal}>
                        x
                    </button>
                </div>
                <div className="content">
                        <div>
                            <label>¿Desea solicitar factura a nombre de un tercero?</label>
                            <div className="flex">
                                <button className={!pagoTercero ? 'active' : ''} onClick={() => setPagoTercero(false)}>No</button>
                                <button className={pagoTercero ? 'active' : ''} onClick={() => setPagoTercero(true)}>Si</button>
                            </div>
                        </div>
                        {pagoTercero && terceros && terceros.length > 0 && (
                            <div className="seleccion-persona">
                                <InputComp label="Seleccionar tercero" name="idPersonaTercero" type="select" form={form} setForm={setForm} catalogos={terceros} catalogoValue={'idPersonaTercero'} catalogoLabel={'razonSocialTercero'} />
                            </div>
                        )}
                </div>
                <div className="actions">
                    <button onClick={closeModal}>Cerrar</button>
                    <button onClick={handleSubmit}>Continuar</button>
                </div>
            </div>
        </div>
    )
}